<script setup lang="ts">
    import type { CustomField } from "common";
    import { useOrderStore } from "~/composables/store/order";

    const orderStore = useOrderStore();

    const { field } = defineProps<{
        field: CustomField & { type: "boolean" };
    }>();

    const fieldModel = computed({
        get() {
            return (
                orderStore.currentOrder.customFields.find(
                    (cf) => cf.id === field.id,
                )?.value ?? false
            );
        },
        set(value: string) {
            orderStore.helpers.setCustomField(field.id, value);
        },
    });

    const r$ = orderStore.validation.r$;

    const regleField = computed(() =>
        r$.$fields.customFields.$each.find((rf) => rf.$value.id === field.id),
    );
</script>
<template>
    <VCheckbox
        v-model="fieldModel"
        :label="field.label + (field.required ? ' *' : '')"
        variant="outlined"
        density="compact"
        hide-details="auto"
        :error-messages="regleField?.$fields.value.$errors"
        @focusout="regleField?.$fields.value.$touch"
    />
</template>
